export enum DialogModalButtons {
  Cancel,
  Ok,
  Confirm,
  Delete,
}
